import { Navigate, useLocation } from 'react-router';
import { useAuth } from '../../auth/AuthContext';
import { t } from '../../i18n/sq';
import { AuthShell } from './AuthShell';
import { ChangePasswordForm } from './ChangePasswordForm';

/**
 * The forced first-login password change, shown full-screen before the app shell. Everyone
 * else changes their password in Settings; old links to this address land there.
 */
export function ChangePasswordPage() {
  const { user, setUser } = useAuth();
  const location = useLocation();

  if (!user?.mustChangePassword) {
    // Once the change is saved the app shell appears and remounts this page, so the route
    // state (set by RequireAuth) is what says "continue into the app" rather than "Settings".
    const justChanged = (location.state as { forced?: boolean } | null)?.forced;
    return <Navigate to={justChanged ? '/' : '/cilesimet/siguria'} replace />;
  }

  return (
    <AuthShell title={t.auth.changePassword}>
      <ChangePasswordForm
        forced
        onChanged={() => setUser({ ...user, mustChangePassword: false })}
      />
    </AuthShell>
  );
}
